// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceCollectionForm__form-b09f89 {
  flex: 1;
  overflow: auto;
  padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/SpaceCollectionForm/SpaceCollectionForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,aAAA;AACF","sourcesContent":[".form {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `SpaceCollectionForm__form-b09f89`
};
module.exports = ___CSS_LOADER_EXPORT___;
